<pc-image-banner 
    [imgUrl]="this.bannerImgUrl || ''"
>
</pc-image-banner>

<div class="site-gutter white-gutter">
    <div class="main-copy-section">
        <div class="wrapper">
            <div class="copy-container">
                <div class="header-container">
                    <h1>Division 9</h1>
                    <h2>Finishes</h2>
                </div>
                <p>
                    To aid in the finishes specification of your commercial construction project, PC Haines provides a variety of services. We can frame metal steel studs, hang & finish gypsum board, and install a wide range of ceiling systems. In addition, we can install sound-absorbing wall units to reduce sound transmission depending on your specifications and client preferences. Our crew is committed to your satisfaction and the integrity of our work. We make it a point to go the extra mile on every job, from start to finish. View our finishing capabilities below.
                </p>
            </div>
            <div class="circles services-circles">
                <pc-services-circles></pc-services-circles>
            </div>
        </div>
    </div>
</div>


<div class="secondary-content-section dark-section">
    <div class="site-gutter">
        <div class="card-container">
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">1</span>
                            <h3>Gypsum Board Shaft Wall Assemblies</h3>
                        </div>
                    </div>
                    <p>Gypsum board shaft wall assemblies are a type of non-load-bearing partition used to enclose elevator shafts, stairwells, and other vertical chases in buildings. These systems are made from gypsum board, a panel made of calcium sulfate dihydrate, which is sandwiched between facing materials like paper. Gypsum board shaft walls offer fire resistance and sound insulation, making them ideal for containing fires and dampening noise between floors. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">2</span>
                            <h3>Non-Structural Metal Framing</h3>
                        </div>
                    </div>
                    <p>Non-structural metal framing, often made of light-gauge steel studs and tracks, is primarily used for interior partitions, ceilings, and column encasements. It's used to provide a framework for attaching finishing materials like gypsum boards. This type of framing doesn't bear the structural loads of a building but serves to shape the interior spaces, allowing for flexibility in design layouts. </p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">3</span>
                            <h3>Gypsum Board</h3>
                        </div>
                    </div>
                    <p>Gypsum board is used for walls and ceilings, providing a smooth surface for interior finishes like paint or wallpaper. Drywall, also known as gypsum board, plasterboard, or wallboard, is a panel made of calcium sulfate dihydrate (gypsum). It's widely used in construction for creating interior walls and ceilings. Drywall is favored for its ease of installation, fire resistance, and ability to provide a smooth surface for painting or applying wallpaper. It's a staple in modern construction.</p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">4</span>
                            <h3>Acoustical Panel Ceilings</h3>
                        </div>
                    </div>
                    <p>Acoustical panel ceilings are used to absorb sound, reduce noise levels, and improve the overall acoustics in a space. They're common in offices, schools, theaters, and conference rooms. Acoustical panels are made from materials that absorb sound waves, like mineral wool or foam. They reduce sound reflections, which lowers noise levels and prevents echoes. This creates a clearer, more pleasant sound environment.</p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">5</span>
                            <h3>Beam and Baffle Ceiling Systems</h3>
                        </div>
                    </div>
                    <p>Beam and baffle ceiling systems use suspended elements to control sound and create visually striking designs, blending functionality with aesthetics. They're great for improving acoustics, hiding mechanical systems, and adding a stylish touch to commercial spaces. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">6</span>
                            <h3>Linear Metal Ceilings</h3>
                        </div>
                    </div>
                    <p>Linear metal ceilings, sleek and contemporary, offer uniform looks, conceal utilities, and enhance acoustics in modern buildings. They're a go-to for an aesthetic that's both functional and visually appealing.</p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">7</span>
                            <h3>Suspended Wood Ceilings</h3>
                        </div>
                    </div>
                    <p>Suspended wood ceilings bring natural warmth, improve acoustics, and hide utilities in style. Really elevates space! They also add a touch of luxury, help with sound absorption, and can be customized with different wood types and finishes for unique designs. </p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">8</span>
                            <h3>Monolithic Acoustical Gypsum Ceilings</h3>
                        </div>
                    </div>
                    <p>Monolithic acoustical gypsum ceilings are seamless, smooth ceilings made from gypsum that help control sound and create a clean, modern look. Really effective for large spaces. They manage sound, enhance aesthetics, and are great for open-plan areas where you want a sleek design without visual interruptions. Perfect for places like offices, theaters, or galleries. </p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">9</span>
                            <h3>Wood Veneer Wall Panels</h3>
                        </div>
                    </div>
                    <p>Wood veneer wall panels are thin slices of real wood bonded to a core material, offering the look of solid wood but at a fraction of the cost and weight. They add warmth and elegance to interiors. They're used to create stylish, high-end finishes in homes, offices, or commercial spaces, and are excellent for feature walls, wainscoting, or to add texture and depth to a room.</p>
                </div>
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">10</span>
                            <h3>Fabric-Wrapped Panels</h3>
                        </div>
                    </div>
                    <p>Fabric-wrapped panels are panels designed to improve room acoustics, made by wrapping absorbent material in fabric. They control sound reflections, improving audio clarity and adding a decorative touch to walls.</p>
                </div>
            </div>
            <div class="card-row">
                <div class="card numbered-card">
                    <div class="header-container">
                        <div class="number-header">
                            <span class="number">11</span>
                            <h3>Wood Panel Grille Wall Systems</h3>
                        </div>
                    </div>
                    <p>Fabric-wrapped panels are panels designed to improve room acoustics, made by wrapping absorbent material in fabric. They control sound reflections, improving audio clarity and adding a decorative touch to walls. </p>
                </div>
                <div class="card">
                </div>
            </div>
        </div>
    </div>
</div>

<pc-seat-belt
    [copy]="'Ready to experience the PC Haines difference? Submit a bid request today.'"
    [buttonText]="'Submit a Request'"
    [buttonUrl]="'/contact-us'"
    [urlFragment]="'bid-request'"
></pc-seat-belt>